import React from 'react';
import Formsy from 'formsy-react';
import FormsyInput from './FormsyInput';
import SVGSearch from '../../svg/Search';

const SearchInput = props => {
  const { placeholder, onChange, value, name } = props;

  const searchTerm = name ? name : 'searchTerm';

  return (
    <div className="cms__search">
      <Formsy>
        <div className="cms__search-icon">
          <SVGSearch />
        </div>
        <FormsyInput
          type="text"
          name={searchTerm}
          autocomplete="off"
          className="input__group cms__search-input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </Formsy>
    </div>
  );
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/form/SearchInput.js